import getEnvironment from './getEnvironment';

export default function getPagesLocation(): string {
  const env = getEnvironment();
  const PAGES_PATH = '/sdk/v1/www';

  const host = (env === 'production') ? 'https://pay.flow.io' : 'https://localhost:3001';

  return `${host}${PAGES_PATH}`;
}
